import React from "react";
import {Trans, useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {withErrorBoundary} from "../../ErrorBoundary";
import {PATHS} from "../../../route-dictionary";
import {ACTIONS, hasGlobalPermission} from "../../../utils/user-access";

const NoRulesText = () => {
  const {t} = useTranslation();

  return (
      <Trans i18nKey="noData.checkRules" values={{link: t("check.defaultRules")}}>
        There are no specific rules for the check, so
        {hasGlobalPermission(ACTIONS.VIEW_DEFAULT_RULES) ?
          <Link to={PATHS.RULES.ROOT}>default rules</Link> :
          "default rules"
        }
        will be used
      </Trans>
  );
};

export default withErrorBoundary(NoRulesText);
